import * as React from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { ALSection } from "./ALSection";
import { TISection } from "./TISection";
import { MTCSection } from "./MTCSection";
import { APD_TGL_NTL } from "./APD_TGL_NTL";
import { LimitsSection } from "./LimitsSection";
import { CargoList } from "./CargoList";
import { RadiusSection } from "./RadiusSection";
import { NonOwnedTrailerSection } from "./NonOwnedTrailerSection";
import { StateMileage } from "./StateMileage";
import { CorgiCoverageQuestions } from "./CorgiCoverageQuestions";

const arraysEqual = (a = [], b = []) =>
  a.length === b.length && a.every((v, i) => v === b[i]);

export function Coverages({ methods }) {
  const { register, control, setValue } = methods;
  useFormContext();

  const step1Carrier = useWatch({ control, name: "step1.carrier" });
  const step8Carrier = useWatch({ control, name: "step8.carrier" });
  const hasAccelerant = (Array.isArray(step1Carrier) ? step1Carrier : step1Carrier ? [step1Carrier] : [])
    .some((c) => String(c).toLowerCase() === "accelerant");
  const normalizedCarriers = Array.isArray(step1Carrier)
    ? step1Carrier
    : step1Carrier
    ? [step1Carrier]
    : [];
  const isCorgiOnly =
    normalizedCarriers.length === 1 && normalizedCarriers[0] === "Corgi Trucking";

  React.useEffect(() => {
    register("step8.carrier");
  }, [register]);

  React.useEffect(() => {
    const list = Array.isArray(step1Carrier)
      ? step1Carrier
      : step1Carrier ? [step1Carrier] : [];
    const normalized = list.map((s) => (s ?? ""));

    if (!arraysEqual(normalized, step8Carrier ?? [])) {
      setValue("step8.carrier", normalized, { shouldDirty: false, shouldValidate: true });
    }
  }, [step1Carrier, step8Carrier, setValue]);

  return (
    <div className="space-y-10">
      {/* Header */}
      <header className="w-full">
        <h2 className="capitalize text-xl font-semibold">
          Coverages (Select coverages to quote)
        </h2>
      </header>

      {/* Coverages */}
      <section className="rounded-xl !mt-0 space-y-3">
        <CorgiCoverageQuestions control={control} />
        <ALSection />
        {!isCorgiOnly && <TISection />}
        <MTCSection />
        <APD_TGL_NTL />
        <NonOwnedTrailerSection />
      </section>

      <LimitsSection />
      <CargoList />
      <RadiusSection />
      {hasAccelerant && <StateMileage />}
    </div>
  );
}
